const apiConfig = {
    b2cScopes: ["https://ettermunkorg.onmicrosoft.com/ettermunk-api/ettermunk.readwrite"],
    webApi: "https://ettermunkapi.andai.hu/api/",
    imageroute: "https://ettermunkapi.andai.hu/images/"
  };

export default apiConfig;
